import { EElementType, ILandingElement } from '~/src/services/projects';
import { fonts } from '~/src/helpers/font';


export const BlockGridColumn: ILandingElement = {
    title: 'BlockGridColumn',
    type: EElementType.BlockGridColumn,
    label: 'Колонка',
    properties: {
        width: 4,
        customStyles: '',
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        paddingVertical: '15',
        paddingHorizontal: '15',
        borderRadius: '15',
    },
    children: [
        {
            title: 'Image',
            type: EElementType.Image,
            label: 'Изображение',
            properties: {
                isActive: true,
                content: '',
                webp: '',
                alt: '',
                customStyles: '',
                customize: {
                    width: '',
                    height: '',
                    placement: 'top',
                },
            },
        },
        {
            title: 'Title',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H4,
                    color: '#656565',
                    textAlign: 'left',
                },
                htmlContent: 'Заголовок',
                customStyles: '',
            },
        },
        {
            title: 'Text',
            type: EElementType.RTE,
            label: 'Описание',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#656565',
                    textAlign: 'left',
                },
                htmlContent: 'Текст...',
                customStyles: '',
            },
        },
        {
            title: 'Button',
            type: EElementType.Button,
            label: 'Кнопка',
            properties: {
                customStyles: '',
                isTargetBlank: false,
                enableCalltouch: false,
            },
            children: [
                {
                    title: 'Text',
                    type: EElementType.Text,
                    label: 'Текст',
                    properties: {
                        customize: {
                            font: fonts.Medium,
                            color: '#FFF',
                            href: '',
                        },
                        content: '',
                        customStyles: '',
                    },
                },
            ],
        },
    ],
};

export const BlockGrid: ILandingElement = {
    title: 'BlockGrid',
    type: EElementType.Block,
    label: 'Блоковая структура',
    properties: {
        customStyles: '',
        addElement: EElementType.BlockGridColumn,
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        marginTop: '',
        marginBottom: '',
    },
};
